/* mootlu-shop.js — cart AJAX bridge + toasts (no drawer/search UI).
 *
 * Cart drawer and search overlay are React-only (bundle.js).
 * PDP gallery/variants stay in mootlu-product.js (no React on PDP).
 */
(function () {
  'use strict';

  if (window.__mootluShopLoaded) return;
  window.__mootluShopLoaded = true;

  var DATA = window.MOOTLU_DATA || {};
  var routes = DATA.routes || {};
  var T = DATA.t || {};
  var FETCH_TIMEOUT_MS = 15000;

  function routeToAjaxJs(routeUrl, fallback) {
    var u = (routeUrl || fallback || '').trim() || fallback;
    if (u.slice(-3) === '.js') return u;
    return u.replace(/\/$/, '') + '.js';
  }

  var cartAddUrl = routes.cart_add_js_url || routeToAjaxJs(routes.cart_add_url, '/cart/add');
  var cartFetchUrl = routes.cart_js_url || routeToAjaxJs(routes.cart_url, '/cart');

  function t(key, fallback) {
    var v = T[key];
    return typeof v === 'string' && v.length ? v : fallback || '';
  }

  function announce(msg, assertive) {
    var region = document.getElementById(
      assertive ? 'mootlu-aria-live-assertive' : 'mootlu-aria-live'
    );
    if (!region) return;
    region.textContent = '';
    setTimeout(function () {
      region.textContent = msg;
    }, 50);
  }

  var toastContainer;
  function toast(msg, kind) {
    if (!toastContainer) {
      toastContainer = document.createElement('div');
      toastContainer.id = 'mootlu-toasts';
      toastContainer.style.cssText =
        'position:fixed;top:88px;right:20px;z-index:1200;display:flex;flex-direction:column;gap:10px;pointer-events:none;';
      document.body.appendChild(toastContainer);
    }
    var el = document.createElement('div');
    var bg = kind === 'error' ? 'rgba(70,18,18,0.9)' : 'rgba(10,10,18,0.92)';
    var bd = kind === 'error' ? 'rgba(255,115,115,0.6)' : 'rgba(191,163,255,0.4)';
    var fg = kind === 'error' ? '#ffb4b4' : '#f5f3f0';
    el.setAttribute('role', kind === 'error' ? 'alert' : 'status');
    el.style.cssText =
      'pointer-events:auto;background:' +
      bg +
      ';color:' +
      fg +
      ';border:1px solid ' +
      bd +
      ';padding:14px 20px;font-family:DM Sans,sans-serif;font-size:12px;letter-spacing:0.05em;backdrop-filter:blur(20px);max-width:320px;transform:translateX(20px);opacity:0;transition:all 0.3s ease;';
    el.textContent = msg;
    toastContainer.appendChild(el);
    requestAnimationFrame(function () {
      el.style.transform = 'translateX(0)';
      el.style.opacity = '1';
    });
    setTimeout(function () {
      el.style.transform = 'translateX(20px)';
      el.style.opacity = '0';
      setTimeout(function () {
        el.remove();
      }, 300);
    }, 3500);
    announce(msg, kind === 'error');
  }

  var cart = null;
  var lastCartSignature = null;
  var cartMutationChain = Promise.resolve();

  function runCartMutation(fn) {
    var run = cartMutationChain.then(fn, fn);
    cartMutationChain = run.catch(function () {});
    return run;
  }

  function cartSignature(data) {
    if (!data) return '';
    var lines = (data.items || [])
      .map(function (it) {
        return String(it.key || it.id) + ':' + String(it.quantity || 0);
      })
      .sort()
      .join('|');
    return String(data.token || '') + ':' + String(data.item_count || 0) + ':' + String(data.total_price || 0) + ':' + lines;
  }

  function syncCartBadges() {
    if (!cart) return;
    var n = cart.item_count || 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
    });
  }

  function emitCartUpdated() {
    try {
      document.dispatchEvent(
        new CustomEvent('mootlu:cart-updated', {
          detail: {
            itemCount: cart.item_count || 0,
            totalPrice: cart.total_price || 0,
            currency: cart.currency,
          },
        })
      );
    } catch (e) {}
  }

  function emitCartUpdatedIfChanged() {
    var sig = cartSignature(cart);
    if (sig === lastCartSignature) return;
    lastCartSignature = sig;
    emitCartUpdated();
  }

  function fetchWithTimeout(url, options) {
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = controller
      ? setTimeout(function () {
          controller.abort();
        }, FETCH_TIMEOUT_MS)
      : null;
    var opts = options || {};
    if (controller) opts.signal = controller.signal;
    return fetch(url, opts).then(
      function (r) {
        if (timer) clearTimeout(timer);
        return r;
      },
      function (err) {
        if (timer) clearTimeout(timer);
        throw err;
      }
    );
  }

  function readJson(res) {
    return res.text().then(function (text) {
      if (!text) return {};
      try {
        return JSON.parse(text);
      } catch (e) {
        throw new Error(t('cart_add_failed', 'Could not add to cart.'));
      }
    });
  }

  function fetchCart() {
    return runCartMutation(function () {
      return fetchWithTimeout(cartFetchUrl, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      })
        .then(readJson)
        .then(function (data) {
          cart = data;
          syncCartBadges();
          emitCartUpdatedIfChanged();
          return data;
        });
    });
  }

  function parseVariantIdFromForm(form) {
    var raw = form.querySelector('[data-variant-id]');
    var id = raw && raw.value ? String(raw.value).trim() : '';
    if (!id) {
      var fd = new FormData(form);
      id = String(fd.get('id') || '').trim();
    }
    return id && /^\d+$/.test(id) ? id : '';
  }

  function addItem(form) {
    var variantId = parseVariantIdFromForm(form);
    if (!variantId) {
      return Promise.reject(new Error(t('cart_add_failed', 'Could not add to cart.')));
    }
    var qtyInput = form.querySelector('[data-qty-input], [name="quantity"]');
    var quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;

    var body = new FormData(form);
    body.set('id', variantId);
    body.set('quantity', String(quantity));

    return runCartMutation(function () {
      return fetchWithTimeout(cartAddUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: body,
        credentials: 'same-origin',
      }).then(function (r) {
        return readJson(r).then(function (resBody) {
          if (!r.ok) {
            var msg =
              (resBody && (resBody.description || resBody.message)) ||
              t('cart_add_failed', 'Could not add to cart.');
            throw new Error(msg);
          }
          if (resBody && resBody.status && Number(resBody.status) >= 400) {
            throw new Error(
              resBody.description || resBody.message || t('cart_add_failed', 'Could not add to cart.')
            );
          }
          return resBody;
        });
      });
    });
  }

  function openDrawer() {
    document.dispatchEvent(new CustomEvent('mootlu:open-cart'));
  }

  function closeDrawer() {
    document.dispatchEvent(new CustomEvent('mootlu:close-cart'));
  }

  function openSearch() {
    document.dispatchEvent(new CustomEvent('mootlu:open-search'));
  }

  function closeSearch() {
    document.dispatchEvent(new CustomEvent('mootlu:close-search'));
  }

  function openFrameSelector() {
    document.dispatchEvent(new CustomEvent('mootlu:open-frame-selector'));
  }

  function closeFrameSelector() {
    document.dispatchEvent(new CustomEvent('mootlu:close-frame-selector'));
  }

  function setAddBtnPending(btn, label, pending) {
    if (!btn) return;
    btn.disabled = pending;
    if (label) {
      label.textContent = pending ? t('cart_adding', 'Adding…') : label.dataset.mootluPrevLabel || '';
    }
  }

  function resetAddBtn(btn, label) {
    if (!btn) return;
    var soldOut = btn.getAttribute('aria-disabled') === 'true';
    btn.disabled = soldOut;
    if (label && label.dataset.mootluPrevLabel) {
      label.textContent = label.dataset.mootluPrevLabel;
    }
  }

  function attach() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;
      e.preventDefault();

      var btn = form.querySelector('[data-add-to-cart], button[type="submit"], [name="add"]');
      var label = btn && btn.querySelector('[data-add-label]');
      if (btn && btn.disabled) return;

      if (label && !label.dataset.mootluPrevLabel) {
        label.dataset.mootluPrevLabel = label.textContent;
      }
      setAddBtnPending(btn, label, true);

      addItem(form)
        .then(function (addedItem) {
          return fetchCart()
            .catch(function () {
              return null;
            })
            .then(function () {
              return addedItem;
            });
        })
        .then(function (addedItem) {
          try {
            document.dispatchEvent(
              new CustomEvent('mootlu:cart-added', { detail: { item: addedItem } })
            );
            document.dispatchEvent(
              new CustomEvent('mootlu:cart-updated', {
                detail: {
                  itemCount: cart ? cart.item_count || 0 : 0,
                  totalPrice: cart ? cart.total_price || 0 : 0,
                },
              })
            );
          } catch (err) {}
          openDrawer();
          toast(t('cart_added', 'Added to cart'));
        })
        .catch(function (err) {
          try {
            console.warn('[mootlu-shop] add to cart failed', err);
          } catch (logErr) {}
          toast(
            err && err.message ? err.message : t('cart_add_failed', 'Could not add to cart.'),
            'error'
          );
        })
        .then(function () {
          resetAddBtn(btn, label);
        });
    });

    document.addEventListener('click', function (e) {
      var target = e.target;
      if (target.closest && target.closest('[data-mootlu-cart-toggle]')) {
        e.preventDefault();
        openDrawer();
      }
    });
  }

  function init() {
    attach();
    fetchCart().catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.MootluShop = {
    openDrawer: openDrawer,
    closeDrawer: closeDrawer,
    openSearch: openSearch,
    closeSearch: closeSearch,
    openFrameSelector: openFrameSelector,
    closeFrameSelector: closeFrameSelector,
    refresh: fetchCart,
    runCartMutation: runCartMutation,
    toast: toast,
  };
})();
